{
  "logoAlt": "Curipop Logo",
  "welcomeTag": "Welcome back!",
  "headline": "Let's Explore!",
  "subhead": "Sign in to start your learning adventure",
  "actions": {
    "google": "Sign in with Google"
  },
  "errors": {
    "googleUnavailable": "Google sign-in is currently unavailable."
  },
  "legal": {
    "prefix": "By continuing, you agree to our",
    "terms": "Terms of Service",
    "and": "and",
    "privacy": "Privacy Policy"
  }
}
